<template>
  <div>
    <b-card>
      <div id="telegram-login-button"></div>
      <br>
      <b-button @click="sendMessage">send message</b-button>
    </b-card>
  </div>
</template>

<script>
import ScrollLoader from 'vue-scroll-loader'
import {
  BTable, BFormCheckbox, BButton, BCard, BRow, BCol, BAvatar, BBadge, BFormInput
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import {header_token} from '@/views/token.js'
import {taobaoService_dotnet} from '@/views/global.js'
import axios from "axios";
import { onMounted, onUnmounted } from 'vue'

// function onTelegramAuth(user) {
//   console.log('✅ Telegram Login Success:', user)
//   this.handleMeth()
// }

export default {
  components: {
    BTable,
    BButton,
    BFormCheckbox,
    BCard,
    BRow,
    BCol,
    BBadge,
    BAvatar,
    BFormInput,
    flatPickr,
    ScrollLoader,
  },

  data() {
    return {
    }
  },

   mounted() {

    // Expose auth handler to global scope so Telegram widget can call it
    window.onTelegramAuth = this.onTelegramAuth

    const script = document.createElement('script')
    script.src = 'https://telegram.org/js/telegram-widget.js?7'
    script.setAttribute('data-telegram-login', 'peetTestLoginBot') // No @
    script.setAttribute('data-size', 'large')
    script.setAttribute('data-userpic', 'false')
    script.setAttribute('data-onauth', 'onTelegramAuth(user)')
    script.setAttribute('data-request-access', 'write')
    document.getElementById('telegram-login-button').appendChild(script)
  },

  created() {
    this.splitText()
  },

  methods: {
    async splitText() {
      var text = 'ระบบได้ทำการส่งลิ้งกู้รหัสผ่านไปที่ Email : abc@gmail.com แล้ว กรุณาตรวจสอบ Email ของท่าน'
      var myArray = text.split("กรุณาตรวจสอบ Email ของท่าน");
      var word = myArray[0]
      console.log("myArray: ", word);
    },
    onTelegramAuth(user) {
      console.log('handleMeth: ', user)
    },
    async sendMessage() {
      console.log("senddd");
      
      const token = '7840605182:AAGicoEzDmlR5sme_Mytb7Tp-KWIJ7H0DsY'
      const chatId = '7299676102'
      const message = 'Hello from Peet'

      const url = `https://api.telegram.org/bot${token}/sendMessage`
      try {
        await axios.post(url, {
          chat_id: chatId,
          text: message,
        })
        alert('Message sent!')
      } catch (err) {
        console.error(err)
        alert('Failed to send message')
      }
    },
  }
}
</script>
<style>
</style>
